"use strict";

module.exports = function(Chart) {

	Chart.Line = function(context, config) {
		config.type = 'line';

		return new Chart(context, config);
	};

};


/*****************
 ** WEBPACK FOOTER
 ** ./DeliveryCreate/UI/~/chart.js/src/charts/Chart.Line.js
 ** module id = 220
 ** module chunks = 0
 **/